import React from 'react'
import Button from './Button'

export default function PhoneButton({ phoneNumber, children, variant = 'secondary', size = 'lg', className, ariaLabel, ...props }) {
  if (!phoneNumber) return null

  return (
    <Button
      onClick={() => window.location.href = `tel:${phoneNumber}`}
      variant={variant}
      theme="dark"
      size={size}
      fullWidth
      className={className}
      ariaLabel={ariaLabel || `Call ${phoneNumber}`}
      {...props}
    >
      {children}
    </Button>
  )
}
